export enum INSTANCE_BACK_OFFICE {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=850990161
     */
    CHANGE_SITE = 'INSTANCE_BACK_OFFICE.CHANGE_SITE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?view=multi&search=key::ADMIN.NAV.INSTANCES.TITLE
     */
    INSTANCES_TITLE = 'ADMIN.NAV.INSTANCES.TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?view=multi&search=key::ADMIN.NAV.INSTANCES.MANAGEMENT
     */
    MANAGEMENT = 'ADMIN.NAV.INSTANCES.MANAGEMENT',
}
